<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="14.644" height="13.598" viewBox="0 0 14.644 13.598" stroke="currentColor" focusable="false" aria-hidden="true">
        <g transform="matrix(0.819, 0.574, -0.574, 0.819, -0.478, 12.395)">
            <line x2="4.667" transform="translate(0 -4.476)" fill="none" stroke-linecap="round" stroke-width="3"/>
            <line x1="0.137" y2="11.343" transform="translate(4.667 -15.818)" fill="none" stroke-linecap="round" stroke-width="3"/>
        </g>
    </svg>
</template>